import { Outlet } from 'react-router-dom';

import App from '../App';
import FixNavigate from '../components/common/FixNavigate';
import AuthLayout from '../layout/auth.layout';
import ForgotPassword from '../pages/auth/ForgotPassword';
import LevelUpPassword from '../pages/auth/LevelUpPassword';
import Login from '../pages/auth/Login';
import Logout from '../pages/auth/Logout';
import PasslessLogin from '../pages/auth/PasslessLogin';
import Register from '../pages/auth/Register';
import ResetPassword from '../pages/auth/ResetPassword';
import ResetPasswordNavigate from '../pages/auth/ResetPasswordNavigate';
import ErrorPage from '../pages/site/ErrorPage';

const AuthRouterChildren = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'login',
        element: (
          <AuthLayout>
            <Login />
          </AuthLayout>
        ),
      },
      {
        path: 'register',
        element: (
          <AuthLayout>
            <Register />
          </AuthLayout>
        ),
      },
      {
        path: 'forgot-password',
        element: (
          <AuthLayout>
            <ForgotPassword />
          </AuthLayout>
        ),
      },
      {
        path: 'reset-password',
        element: (
          <AuthLayout>
            <ResetPassword />
          </AuthLayout>
        ),
      },
      {
        path: 'level-up-password',
        element: (
          <AuthLayout>
            <LevelUpPassword />
          </AuthLayout>
        ),
      },
      {
        path: 'passless-login',
        element: (
          <AuthLayout>
            <PasslessLogin />
          </AuthLayout>
        ),
      },
      {
        path: 'logout',
        element: <Logout />,
      },
    ],
  },
];

const AuthRouter = [
  {
    path: '/en-US',
    element: (
      <App>
        <Outlet />
      </App>
    ),
    errorElement: <ErrorPage />,
    children: AuthRouterChildren,
  },
  {
    path: '/fr-FR',
    element: (
      <App>
        <Outlet />
      </App>
    ),
    errorElement: <ErrorPage />,
    children: AuthRouterChildren,
  },
  {
    path: '/reset-password',
    element: (
      <App>
        <ResetPasswordNavigate />
      </App>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/login',
    element: <FixNavigate to="/login" />,
    errorElement: <ErrorPage />,
  },
];

export default AuthRouter;
